import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostUseDefaultAdminFeatureFlagByCustomerIdRequest = {
	featureFlag: string,
	customerId: number,
	shardName?: string;
};

export const postUseDefaultAdminFeatureFlagByCustomerId =
	createPostEndpoint<PostUseDefaultAdminFeatureFlagByCustomerIdRequest, void>(
		(request) => `/api/v3/core/feature-flags/${request.featureFlag}/customers/${request.customerId}/use-default`, {
			headers: (request) => {
				if (request?.shardName) {
					return { [ HttpHeader.Shard ]: request.shardName };
				}

				return {};
			},
			requestTransform: ({ customerId, featureFlag, shardName, ...rest }) => rest,
			skipAuthRefresh: true
		}
	);
